import React, {useContext} from "react";

const DeployContext = React.createContext();

function Deploy({ type, children }) {

  return (
    <DeployContext.Provider value={{ type }}>
      { children }
    </DeployContext.Provider>
  );
}

DeployContext.defaultProps = {
  type: "tool"
}

function useDeployContext() {
  const context = useContext(DeployContext);

  if (!context) {
    throw new Error(
      `Toggle compound components cannot be rendered outside the Toggle component`,
    )
  }

  return context;
}



function Widget({children})
{
  const {type} = useDeployContext();
  return type === "widget" ? children : null;
}

function Tool({children})
{
  const {type} = useDeployContext();
  return type === "tool" ? children : null;
}

Deploy.Widget = Widget
Deploy.Tool = Tool


export default Deploy;
